import axios from 'axios';
import { apiBaseUrl } from '../config/GlobalConfig';
import {v4 as uuidv4} from 'uuid';
import {getLocalStorageValue, setSessionStorage} from "../utils/utils";



axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    switch (error.response.status) {
      case 401:
        //navigate('/register');
        break;
      case 404:
      case 403:
        //navigate('/');
        break;
    }
    return Promise.reject(error);
  },
);

export const sessionId = () => {
  let sessionId = getLocalStorageValue("MgpSessionId");
  if(!sessionId) {
    sessionId = uuidv4();
    setSessionStorage("MgpSessionId", sessionId);
  }
  return sessionId;
}


export const authApi = (headers?: Map<string, string>) => {
  const mgpHeaders = {common: {}} as any;
  mgpHeaders.common['X-Channel-Id'] = 'WEB';
  mgpHeaders.common['Accept'] = 'application/json';
  mgpHeaders.common['X-Request-Id'] = sessionId();
  mgpHeaders.common['Access-Control-Allow-Origin'] = '*';
  if(headers && headers.size > 0) {
    headers.forEach((v,k) => {
      mgpHeaders[k] = v;
    });
    
  }
  let axiosInstance = axios.create({
    baseURL:  apiBaseUrl,
    headers: mgpHeaders
  });

  return axiosInstance;
};

